import React from "react";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

export default function TooltipTrigger({id, content, placement, children}) {

    const renderTooltip = () => {
        return (
            <Tooltip id={id} style={{zIndex: 20000}}>{content}</Tooltip>
        )
    }

    return (
        <>
            <OverlayTrigger placement={placement} overlay={renderTooltip()}>
                {children}
            </OverlayTrigger>
        </>
    )
}
